"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetDraftUpdateRequestToJSON = exports.AdSetDraftUpdateRequestFromJSONTyped = exports.AdSetDraftUpdateRequestFromJSON = exports.instanceOfAdSetDraftUpdateRequest = void 0;
var runtime_1 = require("../runtime");
var AssetFormat_1 = require("./AssetFormat");
var BidStrategyRequest_1 = require("./BidStrategyRequest");
var BudgetRequest_1 = require("./BudgetRequest");
var CostModel_1 = require("./CostModel");
var FrequencyCap_1 = require("./FrequencyCap");
var Pacing_1 = require("./Pacing");
var Targets_1 = require("./Targets");
/**
 * Check if a given object implements the AdSetDraftUpdateRequest interface.
 */
function instanceOfAdSetDraftUpdateRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetDraftUpdateRequest = instanceOfAdSetDraftUpdateRequest;
function AdSetDraftUpdateRequestFromJSON(json) {
    return AdSetDraftUpdateRequestFromJSONTyped(json, false);
}
exports.AdSetDraftUpdateRequestFromJSON = AdSetDraftUpdateRequestFromJSON;
function AdSetDraftUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel_1.CostModelFromJSON)(json['cost_model']),
        'budget': !(0, runtime_1.exists)(json, 'budget') ? undefined : (0, BudgetRequest_1.BudgetRequestFromJSON)(json['budget']),
        'bidMicroAmount': !(0, runtime_1.exists)(json, 'bid_micro_amount') ? undefined : json['bid_micro_amount'],
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (0, Targets_1.TargetsFromJSON)(json['targets']),
        'pacing': !(0, runtime_1.exists)(json, 'pacing') ? undefined : (0, Pacing_1.PacingFromJSON)(json['pacing']),
        'assetFormat': !(0, runtime_1.exists)(json, 'asset_format') ? undefined : (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'bidStrategy': !(0, runtime_1.exists)(json, 'bid_strategy') ? undefined : (0, BidStrategyRequest_1.BidStrategyRequestFromJSON)(json['bid_strategy']),
        'mobileAppId': !(0, runtime_1.exists)(json, 'mobile_app_id') ? undefined : json['mobile_app_id'],
        'reservationId': !(0, runtime_1.exists)(json, 'reservation_id') ? undefined : json['reservation_id'],
    };
}
exports.AdSetDraftUpdateRequestFromJSONTyped = AdSetDraftUpdateRequestFromJSONTyped;
function AdSetDraftUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'dataset_id': value.datasetId,
        'category': value.category,
        'cost_model': (0, CostModel_1.CostModelToJSON)(value.costModel),
        'budget': (0, BudgetRequest_1.BudgetRequestToJSON)(value.budget),
        'bid_micro_amount': value.bidMicroAmount,
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'pacing': (0, Pacing_1.PacingToJSON)(value.pacing),
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'bid_strategy': (0, BidStrategyRequest_1.BidStrategyRequestToJSON)(value.bidStrategy),
        'mobile_app_id': value.mobileAppId,
        'reservation_id': value.reservationId,
    };
}
exports.AdSetDraftUpdateRequestToJSON = AdSetDraftUpdateRequestToJSON;
